module.exports = __webpack_public_path__ + "img/Become_a_Mentor_F.0845ff07.jpg";